import { ColouredText } from './Footer.styles'

export type ColouredTextItemsProps = {
  colouredTextItems: { url: string; title: string; color: string }[]
  domain: string
}

const ColouredTextItems = ({ colouredTextItems, domain }: ColouredTextItemsProps) => {
  const showNoFollow = domain === 'housekeeper.com'

  return (
    <>
      {colouredTextItems.map((item) => (
        <ColouredText
          href={`https://${item.url}`}
          key={item.url}
          color={item.color}
          rel={showNoFollow ? 'nofollow' : ''}
          role='listitem'
        >
          {item.title}
        </ColouredText>
      ))}
    </>
  )
}

export default ColouredTextItems
